import React from "react";
import { bonuses, extraGift } from "../data/content";
import { BonusThumb } from "./BonusThumb";
import { CtaButton } from "./CtaButton";
export function Bonuses() {
  return <section className="bg-paper py-20 md:py-28" aria-labelledby="bonuses-title" data-id="element-34" data-mp="av39r46tfp6f">
      <div className="mx-auto max-w-6xl px-5 md:px-8" data-id="element-35" data-mp="at8v27m50tas">
        <div className="mx-auto max-w-2xl text-center" data-id="element-36" data-mp="fsv9gkdpcfl6">
          <p className="font-display text-lg font-semibold text-muted md:text-xl" data-id="element-37" data-mp="1ueuk65oriry">Y esto no termina en el ebook</p>
          <h2 id="bonuses-title" className="mt-3 font-display text-3xl font-semibold leading-tight text-ink md:text-[2.75rem]" data-id="element-38" data-mp="5wi6evw9opdr">
            Los 8 bonos exclusivos
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-muted" data-id="element-39" data-mp="3szwqt6vas43s">
            También recibís ocho guías prácticas y un regalo extra para llevar todo en el celular.
          </p>
        </div>

        <ul className="mt-12 grid gap-4 md:grid-cols-2" data-id="element-40" data-mp="1r9l7vhbvw348">
          {bonuses.map(b => <li key={b.title} className="flex items-start gap-4 rounded-3xl bg-white p-4 ring-1 ring-line sm:gap-5 sm:p-5" data-id="element-41" data-mp="3idwnnhlet8k6">
              <BonusThumb icon={b.icon} tone={b.tone} label={b.number} data-id="element-42" data-mp="3dek3j4lxafla" />
              <div className="min-w-0 flex-1 pt-1" data-id="element-43" data-mp="3r79or6tmnghc">
                <h3 className="text-lg font-bold leading-snug text-ink" data-id="element-44" data-mp="3r5yqtnmv52y5">{b.title}</h3>
                <p className="mt-1.5 text-[0.95rem] leading-relaxed text-muted" data-id="element-45" data-mp="3n5ohq23rxwf2">{b.text}</p>
              </div>
            </li>)}
          <li className="flex items-start gap-4 rounded-3xl bg-coral-soft p-4 ring-2 ring-sun sm:gap-5 sm:p-5 md:col-span-2" data-id="element-46" data-mp="2ughb0fu620iq">
            <BonusThumb icon={extraGift.icon} tone={extraGift.tone} label="Extra" data-id="element-47" data-mp="38gik2ikl4e9a" />
            <div className="min-w-0 flex-1 pt-1" data-id="element-48" data-mp="33hfhr5vzom50">
              <p className="text-xs font-extrabold text-ink" data-id="element-49" data-mp="33fujp6agul2e">{extraGift.number}</p>
              <h3 className="mt-0.5 text-lg font-bold leading-snug text-ink" data-id="element-50" data-mp="noq6mx4nxr09">{extraGift.title}</h3>
              <p className="mt-1.5 text-[0.95rem] leading-relaxed text-muted" data-id="element-51" data-mp="iq57l115ddde">{extraGift.text}</p>
            </div>
          </li>
        </ul>

        <p className="mt-6 text-center text-sm text-muted" data-id="element-52" data-mp="3cl99x52ljxx9">
          Todo en formato digital PDF. Sin depender de archivos Word o Excel adicionales.
        </p>

        <div className="mt-10 flex flex-col items-center gap-6 rounded-3xl bg-ink p-6 text-center text-cream sm:p-8 md:flex-row md:justify-between md:text-left" data-id="element-53" data-mp="3lk4dsai64vxe">
          <div data-id="element-54" data-mp="2tsyic7de7meg">
            <p className="font-display text-2xl font-semibold" data-id="element-55" data-mp="2ttgbuw8o7mio">Todo en un solo paquete</p>
            <p className="mt-1 text-cream/75" data-id="element-56" data-mp="2xt8rfswhesxj">1 ebook + 8 bonos + 1 kit para el celular = 10 archivos PDF</p>
          </div>
          <CtaButton size="md" data-id="element-57" data-mp="32rjzby37utd4">Quiero mi kit completo</CtaButton>
        </div>
      </div>
    </section>;
}